import React from 'react';
import { Card, SectionTitle, RankBadge, StatBar } from './UI';
import { getRank } from '../lib/claude';

const LEADERBOARD = [
  { name: 'Bebang Diskarte', elo: 1240, emoji: '👑', streak: 14 },
  { name: 'Kuya Franz', elo: 980, emoji: '⚡', streak: 9 },
  { name: 'Ate Mariz', elo: 875, emoji: '🔥', streak: 7 },
  { name: 'Dodong Pugot', elo: 710, emoji: '😎', streak: 5 },
  { name: 'Karen Talbog', elo: 590, emoji: '🌺', streak: 3 },
];

const EVENTS = [
  {
    emoji: '🎊',
    title: 'Pista ng Galing',
    desc: 'Sunday · GCash prizes for the whole barangay!',
    color: 'var(--purple)'
  },
  {
    emoji: '🍔',
    title: 'Jollibee Banat Cup',
    desc: 'Sponsored · Jollibee vouchers sa top 3 winners',
    color: 'var(--coral)'
  },
  {
    emoji: '⚡',
    title: 'Rookie Rumble',
    desc: 'For Bata Pa ranks only · Free to join!',
    color: 'var(--teal)'
  }
];

export default function BarangayScreen({ stats }) {
  const rank = getRank(stats.elo);

  return (
    <div style={{ animation: 'slideUp 0.3s ease' }}>
      <Card style={{ background: 'linear-gradient(135deg, rgba(108,59,255,0.3), rgba(0,212,170,0.1))' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 800 }}>
              Barangay Diskarte 🏘️
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
              12 members · Rank #3 worldwide
            </div>
          </div>
          <span style={{
            padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700,
            background: 'rgba(255,215,0,0.15)', color: 'var(--gold)'
          }}>🥇 Gold</span>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 6 }}>
            <span style={{ color: 'var(--text-muted)' }}>Progress toward Pista ng Galing</span>
            <span style={{ fontWeight: 600 }}>72%</span>
          </div>
          <StatBar value={72} max={100} color="var(--gold)" />
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
            Only 3 days left — keep fighting, mga pare!
          </div>
        </div>
      </Card>

      <Card>
        <SectionTitle>Top players right now 🏆</SectionTitle>
        {LEADERBOARD.map((player, i) => {
          const r = getRank(player.elo);
          const isMe = i === 4;
          return (
            <div
              key={player.name}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 0',
                borderBottom: i < LEADERBOARD.length - 1 ? '1px solid var(--border)' : 'none',
                opacity: isMe ? 1 : 0.85
              }}
            >
              <div style={{
                fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 14,
                width: 24, textAlign: 'center',
                color: i === 0 ? 'var(--gold)' : i === 1 ? '#C0C0C0' : i === 2 ? '#CD7F32' : 'var(--text-muted)'
              }}>
                {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
              </div>
              <div style={{
                width: 38, height: 38, borderRadius: '50%',
                background: r.color + '22', border: `1.5px solid ${r.color}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18
              }}>
                {player.emoji}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: isMe ? 'var(--purple)' : 'var(--text)' }}>
                  {isMe ? `${player.name} (Ikaw!)` : player.name}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                  {r.emoji} {r.name} · {player.streak} win streak
                </div>
              </div>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 800,
                color: r.color
              }}>{player.elo}</div>
            </div>
          );
        })}

        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: '10px 0', marginTop: 4,
          border: '1px dashed var(--purple)',
          borderRadius: 10, paddingLeft: 8, paddingRight: 8
        }}>
          <div style={{ width: 24, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13, fontWeight: 800 }}>?</div>
          <div style={{
            width: 38, height: 38, borderRadius: '50%',
            background: 'rgba(108,59,255,0.15)', border: '1.5px dashed var(--purple)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18
          }}>🤖</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--purple)' }}>
              Ikaw · {getRank(stats.elo).emoji} {getRank(stats.elo).name}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
              {stats.battles === 0 ? 'No battles yet — jump in, pre!' : `${stats.battles} laban, ${stats.wins} panalo`}
            </div>
          </div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 800, color: 'var(--purple)' }}>
            {stats.elo}
          </div>
        </div>
      </Card>

      <Card>
        <SectionTitle>Upcoming events 🎯</SectionTitle>
        {EVENTS.map((ev, i) => (
          <div key={ev.title} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '10px 0',
            borderBottom: i < EVENTS.length - 1 ? '1px solid var(--border)' : 'none'
          }}>
            <div style={{
              width: 44, height: 44, borderRadius: 10,
              background: ev.color + '18',
              border: `1px solid ${ev.color}44`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20, flexShrink: 0
            }}>{ev.emoji}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{ev.title}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1 }}>{ev.desc}</div>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
